export default __webpack_public_path__ + "static/media/1t.70f45c47.jpg";